import * as React from 'react';
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { appointementGetById } from '../../../redux/actions/Files.action';
import { searchFinalBill } from '../../../redux/actions/Account.action';

export default function ReferralPage() {

    const id = localStorage.getItem('id')

    const [searchQuery, setSearchQuery] = useState('');
    const dispatch = useDispatch()
    const branchData = useSelector((state) => state.files)
    const billType = useSelector((state) => state.account)


    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId


    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        dispatch(searchFinalBill(userId, newSearchQuery));
    };

    useEffect(() => {
        if (id) {
            dispatch(appointementGetById(id));
        }
    }, [id]);
    return (
        <>
            <div className="mt-[100px]">
                <div className='row justify-content-between border-b pb-4'>
                    <div className='col-6'>
                        <label className='block'>Patient Name</label>
                        <div className="inline-flex gap-2 !text-gray-600 rounded-3 px-3 border-1 mt-1 items-center">
                            <h6 className="mb-0 text-sm">{branchData?.getAppointmentById?.data?.appointmentData?.firstName} {" "} {branchData?.getAppointmentById?.data?.appointmentData?.lastName}</h6>
                            <h6 className="border-l-[1px]  text-sm mb-0 py-2 px-2 !border-[#dadada] ">
                                +91 {branchData?.getAppointmentById?.data?.appointmentData?.phoneNumber}
                            </h6>
                        </div>
                    </div>
                    <div className='col-6 text-end'>
                        <div className='flex justify-end gap-3 font-medium text-lg'>
                            <label className='text-center block text-gray-600 border-r pe-3'><span> Total Coin :</span> <span className='ms-1 border-b border-gray-600'></span></label>
                        </div>
                    </div>
                </div>

                <div className='row mt-4 mb-5'>
                    <div className="col-lg-3">
                        <div className='flex items-center'>
                            <input type="text" name="search" value={searchQuery} onChange={handleSearch} placeholder='Search ...' className='border outline-none focus:border-theme-dark py-2 px-3 rounded-lg' />
                        </div>
                    </div>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Sr No.</Th>
                                <Th>Date</Th>
                                <Th>Refree name</Th>
                                <Th>Coins</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                billType?.finalBillByType?.data?.Billings?.length > 0 ? (
                                    billType?.finalBillByType?.data?.Billings?.map((res, index) => {
                                        return (
                                            <Tr key={res._id}>
                                                <Td>{index + 1}</Td>
                                                <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                <Td>20</Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={12} textAlign={'center'}>No Any Bill</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer >
            </div >
        </>
    );
}
